import React from "react";
import "./NotificationBar.scss";
import { getActiveNotification } from "../../services";
import { INotificationItem } from "../NotificationSetting";
import Helper from "../../../../core/libraries/Helper";

class NotificationBar extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isDisplayed: false,
      content: "",
    };

  }
  hideNotificationBar() {
    this.setState({
      isDisplayed: false,
    });
  }
  async componentDidMount(): Promise<void> {
    await this.fetchActiveNotification();
  }
  async fetchActiveNotification() {
    const fetchItem = await getActiveNotification()
    if(!fetchItem) return;
    const notification = { ...fetchItem, links: JSON.parse(fetchItem.links)} as INotificationItem;
    !!notification && this.setState({
      isDisplayed: true,
      content: Helper.WrapLinksIntoContent(notification.links,notification.message)
    })
  }

  render() {
    const isDisplayed = this.state.isDisplayed;
    let notificationBar;
    if (isDisplayed) {
      notificationBar = (
        <div className="notification-bar ms-Grid">
          <div className="ms-Grid-row notification-bar__wrapper">
            <span
              dangerouslySetInnerHTML={{ __html: this.state.content }}
            ></span>
            <span
              className="icon rb-ic rb-ic-close-dark-blue float-right smaller"
              onClick={() => this.hideNotificationBar()}
            ></span>
          </div>
        </div>
      );
    }
    return <>{notificationBar}</>;
  }
}

export default NotificationBar;
